import { ReportProblemEnum } from 'types';

export const __ReportProblemData = [
    { id: ReportProblemEnum.fraud, title: 'کلاه برداری' },
    { id: ReportProblemEnum.illegalOrUnethical, title: 'غیر قانونی و غیر اخلاقی' },
    { id: ReportProblemEnum.wrongCategory, title: 'دسته بندی اشتباه' },
    { id: ReportProblemEnum.wrongPrice, title: 'قیمت اشتباه' },
    { id: ReportProblemEnum.wrongInformation, title: 'اطلاعات اشتباه' },
    { id: ReportProblemEnum.duplicateOrSpam, title: 'تکراری یا اسپم' },
    { id: ReportProblemEnum.unavailableOrUnresponsive, title: 'نا موجودی یا پاسخگو نبودن' },
    { id: ReportProblemEnum.other, title: 'سایر' },
];
